<template>
  <div>
    <b-row>
      <b-col class="col-12">
        <div class="justify-content-end d-flex flex-wrap">
          <b-button
            v-if="parseInt(form.situacao.id) === 10 && disableForm"
            class="mr-1 mb-1"
            variant="primary"
            @click="atestado"
            >Atestado</b-button
          >

          <b-button
            v-if="parseInt(form.situacao.id) === 10 && disableForm"
            class="mr-1 mb-1"
            variant="primary"
            @click="receita"
            >Receita</b-button
          >

          <b-button
            v-if="parseInt(form.situacao.id) === 10 && disableForm"
            class="mr-1 mb-1"
            variant="primary"
            @click="declaracao"
            >Declaração</b-button
          >

          <b-button
            v-if="parseInt(form.situacao.id) === 10 && disableForm"
            class="mr-1 mb-1"
            variant="primary"
            @click="exame"
            >Solicitação de Exames</b-button
          >

          <b-button
            v-if="disableForm"
            class="mr-1 mb-1"
            variant="outline-success"
            @click="sair"
            >Sair</b-button
          >
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <validation-observer ref="form">
          <b-form @submit.prevent>
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group
                  label="Número Atendimento"
                  label-for="v-numAtendimento"
                >
                  <b-form-input
                    id="v-numAtendimento"
                    v-model="form.numeroAtendimento"
                    placeholder="numAtendimento"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group
                  label="Data Atendimento"
                  label-for="v-dataAtendimento"
                >
                  <flat-pickr
                    v-model="form.dataAtendimento"
                    name="fieldDateData"
                    class="form-control"
                    :disabled="true"
                    :config="{
                      altInput: true,
                      altFormat: 'd/m/Y',
                      enableTime: false,
                      dateFormat: 'Y-m-d\\TH:i:ss\\Z',
                    }"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group
                  label="Data Cancelamento"
                  label-for="v-dataCancelamento"
                >
                  <b-form-input
                    id="v-dataCancelamento"
                    v-model="form.dataCancelamento"
                    placeholder="dataCancelamento"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group
                  label="Tipo de Atendimento"
                  label-for="v-tipoAtendimento"
                >
                  <b-form-input
                    id="v-tipoAtendimento"
                    v-model="form.tipoAtendimento.descricao"
                    placeholder="tipoAtendimento"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group
                  label="Especialidades"
                  label-for="v-especialidade"
                >
                  <b-form-input
                    id="v-especialidade"
                    v-model="form.especialidade.descricao"
                    placeholder="especialidade"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group label="Profissional" label-for="v-profissional">
                  <b-form-input
                    id="v-profissional"
                    v-model="form.profissional.nome"
                    placeholder="profissional"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Solicitante" label-for="v-registro">
                  <b-form-input
                    id="v-registro"
                    v-model="form.registro.nome"
                    placeholder="registro"
                    disabled
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="4">
                <validation-provider
                  #default="{ errors }"
                  name="Hora Inicial"
                  rules="required"
                >
                  <b-form-group label="Hora Inicial" label-for="v-horaInicial">
                    <flat-pickr
                      v-model="form.horaInicial"
                      name="fieldDate"
                      :disabled="disableForm"
                      :config="{
                        altInput: true,
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: 'H:i',
                        time_24hr: true,
                      }"
                    />
                    <small
                      data-cy="v-horaInicial-validate"
                      class="text-danger"
                      >{{ errors[0] }}</small
                    >
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" lg="4">
                <validation-provider
                  #default="{ errors }"
                  name="Hora Final"
                  rules="required"
                >
                  <b-form-group label="Hora Final" label-for="v-horaFinal">
                    <flat-pickr
                      v-model="form.horaFinal"
                      name="fieldDate"
                      :disabled="disableForm"
                      :config="{
                        altInput: true,
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: 'H:i',
                        time_24hr: true,
                      }"
                    />
                    <small data-cy="v-horaFinal-validate" class="text-danger">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" sm="12" lg="4">
                <b-form-group label="CID" label-for="v-doencasCid">
                  <v-select
                    v-model="form.doencasCid"
                    :reduce="(comboDoencasCid) => comboDoencasCid.id"
                    label="nome"
                    :options="comboDoencasCid"
                    multiple
                    :readonly="disableForm"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="12" md="4" lg="4">
                <b-form-group
                  label="Unidade Atendimento"
                  label-for="v-unidadeAtendimento"
                >
                  <b-form-input
                    id="v-unidadeAtendimento"
                    v-model="form.unidadeAtendimento.descricao"
                    placeholder="unidadeAtendimento"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="4" lg="4">
                <b-form-group label="Situação" label-for="v-situacao">
                  <v-select
                    v-model="form.situacao.id"
                    :reduce="(comboSituacao) => comboSituacao.id"
                    label="nome"
                    :options="comboSituacao"
                    :disabled="disableForm"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="4" lg="4">
                <b-form-group label="Dias para Atestado" label-for="v-atestado">
                  <b-input-group>
                    <b-form-input
                      id="v-atestado"
                      v-model="form.diasAtestado"
                      placeholder="dias atestado"
                      type="number"
                      :disabled="disableForm"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="12" md="12" lg="12">
                <b-form-group label="Observações" label-for="v-observacao">
                  <b-form-textarea
                    id="v-observacao"
                    v-model="form.observacao"
                    row="2"
                    placeholder="Digite aqui suas observações"
                    :disabled="disableForm"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
    <ButtonsFormVue
      :disable-form="disableForm"
      :loading-button="loading"
      :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
      :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
      @save="salvar"
      @edit="editar"
      @cancel="beforeCancelar"
    />
    <!-- modal -->
    <b-modal ref="my-modal" hide-footer title="Relatorios de Exames">
      <div class="d-block text-center">
        <h3>Solicitação de Exame</h3>
        <b-row>
          <!-- situacaoRegistro -->
          <b-col ols="12" lg="12">
            <b-form-group
              :label="!idExame ? 'Selecione uma opção' : 'Exame selecionado'"
              label-for="v-situacao"
            >
              <v-select
                v-model="idExame"
                label="descricao"
                :options="comboExames"
                rule
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="col-12 mt-1"
          variant="outline-primary"
          block
          :disabled="!idExame"
          @click="printRoportExame"
        >
          Continua
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="col-12 mt-1"
          variant="outline-danger"
          block
          @click="hideModal"
        >
          Cancelar
        </b-button>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BForm,
  BButton,
  BInputGroup,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import mixinsGlobal from "@/mixins";
import vSelect from "vue-select";
import { required } from "@validations";
import Ripple from "vue-ripple-directive";

const INACTIVITY_TIMEOUT = 3 * 60 * 1000;
const AUTO_SAVE_INTERVAL = 10000;
const FIELD_TYPES = {
  STRING: 0,
  BOOLEAN: 1,
  DECIMAL: 2,
  INTEGER: 3,
  DATA: 4,
  TEXTO: 5,
};
const FLAT_PICKR_CONFIGS = {
  date: {
    altInput: true,
    altFormat: "d/m/Y",
    enableTime: false,
    dateFormat: "Y-m-d\TH:i:ss\Z",
  },
  time: {
    altInput: true,
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
  },
};
const TOAST_CONFIG = {
  title: "Atenção",
  variant: "warning",
  solid: true,
  toaster: "b-toaster-top-center",
  noAutoHide: false,
};

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BForm,
    BButton,
    BInputGroup,
    flatPickr,
    ButtonsFormVue,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("atendimentoProfissionalModule", {
      atendimento: (state) => state.atendimento,
    }),
    ...mapState("combosModule", {
      comboDoencasCid: (state) => state.comboDoencasCid,
    }),
    isAtendimentoFinalizado() {
      return parseInt(this.form.situacao.id) === 10;
    },
    showDocumentButtons() {
      return this.isAtendimentoFinalizado && this.disableForm;
    },
  },
  data() {
    return {
      required,
      loading: false,
      loadingCampos: false,
      loadingHistorico: false,
      reportReady: false,
      activeTab: 0,
      previousTab: 0,
      disableForm: true,
      form: {
        id: null,
        numeroAtendimento: "",
        dataAtendimento: "",
        observacao: "",
        situacao: {
          id: null,
          descricao: "",
        },
        dataCancelamento: null,
        profissional: {
          id: null,
          nome: "",
          especialidades: [],
        },
        especialidade: {
          id: null,
          descricao: null,
        },
        registro: {
          id: null,
          nome: "",
        },
        unidadeAtendimento: {
          id: null,
          descricao: null,
        },
        agendamento: null,
        convenio: {
          id: null,
          descricao: null,
        },
        tipoAtendimento: {
          id: null,
          descricao: "",
        },
        horaInicial: "",
        horaAgenda: null,
        horaFinal: null,
        campoAtendimento: [],
        hora: "",
        diasAtestado: 0,
        doencasCid: null,
      },
      comboSituacao: [],
      report: {},
      TYPES_FIELDS: FIELD_TYPES,
      historicos: [],
      comboExames: [],
      idExame: null,
      inactivityTimer: null,
      inactivityTimeout: INACTIVITY_TIMEOUT,
      lastActivity: Date.now(),
      editorOptions: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image"],
          ],
        },
        placeholder: "Digite o conteúdo aqui...",
        theme: "snow",
      },
    };
  },
  methods: {
    // Métodos de ciclo de vida e configuração
    setupActivityListeners() {
      const events = [
        "mousemove",
        "mousedown",
        "keypress",
        "touchmove",
        "click",
        "scroll",
      ];
      events.forEach((event) => {
        document.addEventListener(event, this.resetInactivityTimer);
      });
    },
    removeActivityListeners() {
      const events = [
        "mousemove",
        "mousedown",
        "keypress",
        "touchmove",
        "click",
        "scroll",
      ];
      events.forEach((event) => {
        document.removeEventListener(event, this.resetInactivityTimer);
      });
    },
    // Métodos de gerenciamento de inatividade
    startInactivityTimer() {
      this.resetInactivityTimer();
      this.inactivityTimer = setInterval(() => {
        const currentTime = Date.now();
        const timeSinceLastActivity = currentTime - this.lastActivity;

        if (
          timeSinceLastActivity >= this.inactivityTimeout &&
          !this.disableForm
        ) {
          this.autoSave();
        }
      }, 10000); // Verificar a cada 10 segundos
    },

    resetInactivityTimer() {
      this.lastActivity = Date.now();
    },

    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearInterval(this.inactivityTimer);
        this.inactivityTimer = null;
      }
    },

    autoSave() {
      this.salvarCamposAdicionais(true);
    },
    async editar() {
      this.disableForm = false;
      this.$emit("disable-form-changed", this.disableForm);
      this.aplicarEstiloDisabilitadoEmCampoData();
      this.startInactivityTimer();
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.$emit("disable-form-changed", this.disableForm);
      this.setObejetoLocalEdicao();
      this.aplicarEstiloDisabilitadoEmCampoData();
      const dateName = document.getElementsByName("fieldDateData");
      if (dateName.length > 0) {
        dateName.forEach((element) => {
          if (element.nextElementSibling) {
            element.nextElementSibling.style.backgroundColor = "";
            if (this.disableForm) {
              element.nextElementSibling.style.backgroundColor = "#efefef";
            }
          }
        });
      }
      this.$refs.form.reset();
      this.clearInactivityTimer();
    },
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Deseja realmente sair do cadastro do atendimento?", {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    setObejetoLocalEdicao() {
      this.form = {
        id: this.atendimento.id,
        numeroAtendimento: this.atendimento.numeroAtendimento,
        dataAtendimento: this.atendimento.dataAtendimento,
        observacao: this.atendimento.observacao,
        situacao: this.atendimento.situacao,
        dataCancelamento: this.atendimento.dataCancelamento,
        profissional: this.atendimento.profissional,
        especialidade: this.atendimento.especialidade,
        registro: this.atendimento.registro,
        unidadeAtendimento: this.atendimento.unidadeAtendimento,
        agendamento: this.atendimento.agendamento,
        convenio: this.atendimento.convenio,
        tipoAtendimento: this.atendimento.tipoAtendimento,
        horaInicial: this.atendimento.horaInicial,
        horaAgenda: this.atendimento.horaAgenda,
        horaFinal: this.atendimento.horaFinal,
        campoAtendimento: this.atendimento.campoAtendimento,
        hora: this.atendimento.horaAgenda,
        diasAtestado: this.atendimento.diasAtestado,
        doencasCid: this.atendimento.doencasCid,
      };
    },
    async loadComboSituacao() {
      this.$store
        .dispatch("atendimentoProfissionalModule/getComboSituacao")
        .then((response) => {
          this.comboSituacao = response.data.map((item) => ({
            id: item.id,
            nome: item.descricao,
          }));
        });
    },
    async loadComboDoencasCid() {
      await this.$store.dispatch("combosModule/loadComboDoencasCid");
    },
    salvar(isAutoSave = false) {
      this.$refs.form.validate().then((success) => {
        const objectSave = {
          id: this.form.id,
          observacao: this.form.observacao,
          situacao: this.form.situacao.id,
          horaInicial: this.form.horaInicial,
          horaFinal: this.form.horaFinal,
          diasAtestado: this.form.diasAtestado,
          doencasCid: this.form.doencasCid,
        };
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch("atendimentoProfissionalModule/edit", objectSave)
              .then((response) => {
                if (
                  response.response &&
                  response.response.data &&
                  response.response.data.error
                ) {
                  this.MensagemError("Editar", "Falha ao editar!");
                  return;
                }

                if (isAutoSave) {
                  this.showMessageSuccess(
                    "Salvar",
                    "Salvo automaticamente com sucesso!",
                  );
                  this.loading = false;
                  this.resetInactivityTimer();
                } else {
                  this.showMessageSuccess("Editar", "Editado com sucesso!");
                  this.loadDadosForm();
                  this.loading = false;
                  this.clearInactivityTimer();
                }
              });
            return;
          } catch (error) {
            this.MensagemError("Editar", "Falha ao editar!");
            this.loading = false;
          }
        }
      });
    },
    loadDadosForm() {
      this.loading = true;
      this.$store
        .dispatch(
          "atendimentoProfissionalModule/getAtendimentoById",
          this.$route.params.id,
        )
        .then(() => {
          this.cancelar();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sair() {
      this.$router.go(-1);
    },
    exame() {
      this.report = {};
      this.report = {
        nome: "solicitacao_exame",
        valor: [parseInt(this.form.id)],
      };
      if (this.report.nome === "solicitacao_exame") {
        this.showModal();
        return;
      }
    },
    printRoportExame() {
      this.report = {
        nome: "solicitacao_exame",
        valor: [],
      };
      this.report.valor.push(parseInt(this.form.id));
      this.report.valor.push(parseInt(this.idExame.id));
      this.$store
        .dispatch("reportModule/printReport", this.report)
        .then((response) => {
          if (response.error) {
            this.showMessageSuccess("Limite Excedido", response.message);
          }
          this.openNewAbaBase64(response.data);
        });
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    atestado() {
      this.report = {};
      this.report = {
        nome: "atestado_atendimento",
        valor: [parseInt(this.form.id)],
      };
      this.$store
        .dispatch("reportModule/printReport", this.report)
        .then((response) => {
          if (response.error) {
            this.showMessageSuccess("Limite Excedido", response.message);
          }
          this.openNewAbaBase64(response.data);
        });
    },
    receita(procedimento) {
      this.report = {};
      this.report = {
        paciente: this.atendimento.registro.nome,
        html: procedimento.campo_adicional[0].valor,
      };
      this.$store
        .dispatch("reportModule/printReportReceita", this.report)
        .then((response) => {
          if (response.error) {
            this.MensagemError("Falha Impressão", response.error);
            return;
          }
          this.showMessageSuccess("Impressão", response.msg);
        });
    },
    declaracao() {
      this.report = {};
      this.report = {
        nome: "declaracao_atendimento",
        valor: [parseInt(this.form.id)],
      };
      this.$store
        .dispatch("reportModule/printReport", this.report)
        .then((response) => {
          if (response.error) {
            this.showMessageSuccess("Limite Excedido", response.message);
          }
          this.openNewAbaBase64(response.data);
        });
    },

    formatarDataBr(data) {
      if (data) {
        const date = new Date(`${data}T00:00:00`);
        const formattedDate = date.toLocaleDateString("pt-BR");
        return formattedDate;
      }
    },
  },
  beforeDestroy() {
    this.removeActivityListeners();
    this.clearInactivityTimer();
  },
  async mounted() {
    this.setupActivityListeners();
    this.aplicarEstiloDisabilitadoEmCampoData();
    const dateName = document.getElementsByName("fieldDateData");
    if (dateName.length > 0) {
      dateName.forEach((element) => {
        if (element.nextElementSibling) {
          element.nextElementSibling.style.backgroundColor = "";
          if (this.disableForm) {
            element.nextElementSibling.style.backgroundColor = "#efefef";
          }
        }
      });
    }
    await this.loadComboSituacao();
    await this.loadComboDoencasCid();
    this.$store
      .dispatch(
        "atendimentoProfissionalModule/getAtendimentoById",
        this.$route.params.id,
      )
      .then(() => {
        this.form = JSON.parse(JSON.stringify(this.atendimento));
      });
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
// Adicione os estilos do Quill
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.snow.css";
@import "~quill/dist/quill.bubble.css";
</style>
<style>
.teeth {
  width: 0;
  height: 0;
  border-left: 40px solid transparent;
  border-right: 40px solid transparent;
  border-bottom: 80px solid lightblue;
}

.medical-history {
  padding: 20px;
}

h4 {
  margin-top: 20px;
}

.disabled {
  pointer-events: none;
  opacity: 0.5; /* Você pode adicionar um efeito visual para indicar que o editor está desabilitado */
}

/* Estilos para o Quill Editor */
.ql-disabled {
  pointer-events: none;
  opacity: 0.5;
}

.ql-editor {
  min-height: 150px;
}

.quill-editor {
  margin-bottom: 1rem;
}
</style>
